<template>
     <section class="servers-section">
      <h2 class="section-title">Серверы MyVPS</h2>
      <div class="servers-grid">
        <div class="server-card">
          <div class="server-header">
            <img src="@/assets/images/android/servers/ru.svg" alt="РФ" class="server-icon">
            <span class="server-title">Россия</span>
          </div>
          <ul class="server-list">
            <li>— Отлично подходит для подавляющего большинства ваших повседневных задач</li>
            <li>— Высокая скорость, стабильность</li>
          </ul>
        </div>
        <div class="server-card">
          <div class="server-header">
            <img src="@/assets/images/android/servers/kz.svg" alt="Казахстан" class="server-icon">
            <img src="@/assets/images/android/servers/am.svg" alt="Армения" class="server-icon">
            <span class="server-title">Казахстан, Армения</span>
          </div>
          <ul class="server-list">
            <li>— Для тех, кому нужен сервер в СНГ</li>
            <li>— Высокая скорость, стабильность</li>
          </ul>
        </div>
        <div class="server-card">
          <div class="server-header">
            <img src="@/assets/images/android/servers/de.svg" alt="Германия" class="server-icon">
            <img src="@/assets/images/android/servers/gb.svg" alt="Великобритания" class="server-icon">
            <img src="@/assets/images/android/servers/es.svg" alt="Испания" class="server-icon">
            <img src="@/assets/images/android/servers/fr.svg" alt="Франция" class="server-icon">
            <img src="@/assets/images/android/servers/nl.svg" alt="Нидерланды" class="server-icon">
            <img src="@/assets/images/android/servers/ro.svg" alt="Румыния" class="server-icon">
            <img src="@/assets/images/android/servers/it.svg" alt="Италия" class="server-icon">
            <span class="server-title">Германия, Великобритания, Испания, Франция, Нидерланды, Румыния, Италия</span>
          </div>
          <ul class="server-list">
            <li>— Для TikTok, ChatGPT и др.</li>
            <li>— Хорошая скорость, стабильность ~95–97%</li>
          </ul>
        </div>
        <div class="server-card">
          <div class="server-header">
            <img src="@/assets/images/android/servers/auto.svg" alt="Автосервер" class="server-icon">
            <span class="server-title">Автосервер</span>
          </div>
          <ul class="server-list">
            <li>— ИИ‑алгоритм для автоматического выбора наиболее подходящего сервера</li>
          </ul>
        </div>
        <div class="server-card">
          <div class="server-header">
            <img src="@/assets/images/android/servers/us.svg" alt="США" class="server-icon">
            <img src="@/assets/images/android/servers/tr.svg" alt="Турция" class="server-icon">
            <img src="@/assets/images/android/servers/cn.svg" alt="Китай" class="server-icon">
            <img src="@/assets/images/android/servers/ae.svg" alt="ОАЭ" class="server-icon">
            <img src="@/assets/images/android/servers/ca.svg" alt="Канада" class="server-icon">
            <span class="server-title">США, Турция, Китай, ОАЭ, Канада</span>
          </div>
          <ul class="server-list">
            <li>— Доступ к региональному контенту</li>
            <li>— Скорость: средняя</li>
          </ul>
        </div>
      </div>
    </section>
</template>

<script>

</script>

<style scoped>
.servers-section {
  width: 100%;
  background: white;
  padding: 32px 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
  .servers-grid {
      display: flex; flex-direction: column; gap: 24px;
      width: 90%; max-width: 600px; margin: 16px 0 32px;
    }
    .server-card {
      background: #F7F8FA; border-radius: 12px; padding: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }
    .server-header {
      display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
      margin-bottom: 12px;
    }
    .server-icon { width: 24px; height: 24px; margin-right: 4px; }
    .server-title {
      font-family: 'Play', sans-serif; font-size: 20px; font-weight: 600;
      color: #1B1B27;
    }
    .server-list { list-style: none; padding: 0; margin: 0; }
    .server-list li {
      font-size: 16px; color: #4A4A4A; margin-bottom: 6px; line-height: 1.4;
    }

    .connect-steps {
      position: relative;
      display: flex; flex-direction: column; gap: 35px;
      width: 90%; max-width: 600px; padding-left: 40px;
    }
    .connect-steps::before {
      content: ''; position: absolute; left: 20px; top: 0; bottom: 0;
      width: 2px; background: #DDD;
    }
    .step-card {
      position: relative; padding: 20px 20px 20px 40px;
      background: #fff; border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }
    .step-number {
      position: absolute; left: -2px; top: 50%;
      transform: translate(-85%, -50%);
      width: 50px; height: 50px;
      background: #fff; color: #FAA820;
      border-radius: 50%; border: 3px solid #FAA820;
      display: flex; align-items: center; justify-content: center;
      font-family: 'Play', sans-serif; font-size: 22px; font-weight: 700;
    }
    .step-content { margin-left: 8px; display: flex; flex-direction: column; }
    .step-content p { margin: 4px 0; font-size: 18px; color: #1B1B27; }
</style>
